'use strict';

import React, { Component } from 'react';
import ValidationOverlay from '../../../adminModule/Menu/module/validationOverlay.jsx';
import Dialog from '../../../commonModules/interface/Dialog';
import $ from 'jquery';


class RouteurManagement extends Component {
    constructor(props) {
        super(props);
        var emptyTable = [
            {
                id: "",
                value: ""
            }
        ];
        this.state = {
            //Initiate Default User
            msg: "",
            popupState: this.props.popupState,
            popupStateValidation: "overlay hidden",
            routeurListValue: "",
            routeurList: emptyTable,
            adminAcountUserlistValue: "",
            adminAcountUserlist: emptyTable,
            routeurTypeValue: "sms_user",
            errmsg: "",
            url: ""
        };
        this.onValidation = this.onValidation.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onValidationSucceed = this.onValidationSucceed.bind(this);
        this.onCancelation = this.onCancelation.bind(this);
        this.onChangeRouteur = this.onChangeRouteur.bind(this);
        this.onChangeadminAcountUser = this.onChangeadminAcountUser.bind(this);
        this.onChangeRouteurType = this.onChangeRouteurType.bind(this);

    }
    onValidation= (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.routeurListValue === '') {
            this.setState({errmsg: "Selectionner un routeur"});
            return;
        }
        if (this.state.adminAcountUserlistValue === '') {
            this.setState({errmsg: "Selectionner un compte "});
            return;
        }
       
        var adminAcountUserId = "";
        for (var i = 0; i < this.state.adminAcountUserlist.length; i += 1) {
          if (this.state.adminAcountUserlist[i].id=== this.state.adminAcountUserlistValue){
            adminAcountUserId = this.state.adminAcountUserlist[i].idobj;
          }
        }

        var msg = "Record Routeur connexion : " + this.state.routeurListValue + ", accompte : " + this.state.adminAcountUserlistValue + ", Contrat : " + this.state.routeurTypeValue;
        var url = "routeur/link/new?routeurId=" + this.state.routeurListValue + "&accountEmail=" + adminAcountUserId + "&mode=" + this.state.routeurTypeValue;
        //Active Pop up Security
        this.setState({popupStateValidation: "overlay", msg: msg, url: url});
    }
    onClose= (e) => {
        e.preventDefault();
        this.setState({popupState: "overlay hidden", popupStateValidation: "overlay hidden"});
        this.props.onCloseOverlay();
    }
    onValidationSucceed= () => {
        var emptyTable = [
            {
                id: "",
                value: ""
            }
        ];
        this.setState({
            msg: "",
            popupState: "overlay hidden",
            popupStateValidation: "overlay hidden",
            routeurListValue: "",
            routeurList: emptyTable,
            adminAcountUserlistValue: "",
            adminAcountUserlist: emptyTable,
            errmsg: "",
            url: ""
        });
        this.props.onCloseOverlay();
    }
    onCancelation= () => {
        this.setState({
            popupStateValidation:"overlay hidden",
        })
    }
    onChangeRouteur= (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({routeurListValue: value});
    }
    onChangeRouteurType= (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({routeurTypeValue: value});
    }
    onChangeadminAcountUser= (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({adminAcountUserlistValue: value});
    }
    componentDidMount= () => {
        var methodName = 'Routeur Management';
        var urlBoxFreeOfAssociation = "/routeur/get/list?info=free";

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ',methodName,' reception des données  des associations de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);
                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i]})
                }
            } catch (e) {
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({routeurList: optionTmp, routeurListValue: ""});
        }.bind(this));

        //Get accountUser List
        var urladminAcountUser = "/admin/list";
        this.serverRequestadminAcountUser = $.get(urladminAcountUser, function(result) {
            console.log('[INFO],  reception des données des routeur de PAYGO admin/list');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);
                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i].email, idobj: data.content[i].id})
                }
            } catch (e) {
                console.log('[ERROR], ', methodName, ',Parsing data from serveur admin/list');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({adminAcountUserlist: optionTmp, adminAcountUserlistValue: ""});
        }.bind(this));

    }
    componentWillUnmount= () => {
        try {
            this.serverRequest.abort();
            this.serverRequestadminAcountUser.abort();
        } catch (e) {}
    }
    render() {
        return (
            <Dialog 
                    title="Options"
                    block={this.props.popupState}
                    close={this.onClose }
                    >

                <div className="card">
                    <div className="card-header">
                        <h2>Enregistrer nouvelle Configuration Routeur SMS
                            <small>Nouvelle Configuration Routeur SMS</small>
                        </h2>
                    </div>

                    <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                        {this.state.errmsg}
                        <div className="card-body card-padding">
                            <div className="row">
                                <div className="col-sm-12">
                                    <p className="c-black f-500 m-b-20">Numéro de Routeur</p>
                                    <div className="form-group">
                                        <div className="fg-line">
                                            <select className="form-control" value={this.state.routeurListValue} onChange={this.onChangeRouteur}>
                                                {this.state.routeurList.map(function(optionval) {
                                                    return <option key={optionval.id} value={optionval.id}>{optionval.id}</option>;
                                                })
}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <p className="c-black f-500 m-b-20">Email compte administrateur</p>
                                    <div className="form-group fg-float">
                                        <select className="form-control" value={this.state.adminAcountUserlistValue} onChange={this.onChangeadminAcountUser}>
                                            {this.state.adminAcountUserlist.map(function(optionval) {
                                                return <option key={optionval.id} value={optionval.id}>{optionval.id}</option>;
                                            })
}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <p className="c-black f-500 m-b-20">Mode fonctionnement routeur</p>
                                    <div className="form-group">
                                        <div className="fg-line">
                                            <select className="form-control" value={this.state.routeurTypeValue} onChange={this.onChangeRouteurType}>
                                            <option key="sms_user" value="sms_user">SMS</option>
                                            <option key="sms_code" value="sms_code">CODE</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <button className="btn btn-default btn-icon-text waves-effect" onClick={this.onValidation}>
                            <i className="zmdi zmdi-check-all"></i>
                            Associer Nouveau Routeur</button>
                        <button className="btn btn-default btn-icon-text waves-effect" onClick={this.onClose}>
                            <i className="zmdi zmdi-check-all"></i>
                            Cancel</button>
                    </div>
                </div>

                <ValidationOverlay msg={this.state.msg} popupStateButton={this.state.popupStateValidation} url={this.state.url} onValidation={this.onValidationSucceed} onCancelation={this.onCancelation} />

            </Dialog>
        );
    }
}

export default RouteurManagement

//module.exports = RouteurManagement;



